module.exports = __webpack_public_path__ + "static/media/picutre.f346bc05.png";